import { mutator } from 'satcheljs';
import { setFolderTreeData, FolderTreeLoadStateEnum } from 'owa-folders';
import { onAddSharedFolderSuccess } from '../actions/onAddSharedFolderSuccess';

mutator(onAddSharedFolderSuccess, actionMessage => {
    setFolderTreeData(
        actionMessage.principalSMTPAddress,
        actionMessage.folder,
        FolderTreeLoadStateEnum.Uninitialized
    );
});
